import type { DateTime } from '@ksyos/date-time';
import type { IProcess } from 'common/interfaces/IProcess';
import type { IProcessAction } from 'common/interfaces/IProcessAction';
import type { IRequest } from 'common/interfaces/IRequest';
import type { InsuranceHistory } from 'common/interfaces/patientInsurance';
import type { IAuthenticatedUser } from 'common/utils/IAuthenticatedUser';
import type redux from 'redux';
import {
    AUTHENTICATION_CHECKING,
    AUTHENTICATION_CHECKING_FAILED,
    AUTHENTICATION_LOGGED_IN,
    AUTHENTICATION_LOGOUT,
    SESSION_TIMEOUT_CHANGED,
    USER_ACTIONS_CHANGED,
    USER_DATA_CHANGED,
    USER_HAS_OSAS_MRA_REFERRAL_LETTER_CHANGED,
    USER_INSURANCE_CHANGED,
    USER_PERMISSIONS_CHANGED,
    USER_PROCESSES_CHANGED,
    USER_REQUEST_PROCESSES_CHANGED,
} from './actions';

export interface IUserPermissions {
    canCreateDermaOthProcedure: boolean;
    canCreateGhcConsult: boolean;
}

export interface IAuthenticationState {
    actions?: IProcessAction[];
    failed: boolean;
    id?: string;
    insurance?: InsuranceHistory;
    isChecking: boolean;
    loggedIn: boolean;
    loggingIn: boolean;
    permissions?: IUserPermissions;
    processes?: IProcess[];
    requestProcesses?: IRequest[];
    sessionTimeout?: DateTime;
    token?: string;
    user?: IAuthenticatedUser;
    userHasOsasMraReferralLetter?: boolean;
}

function authentication(
    state: IAuthenticationState = { failed: false, isChecking: true, loggedIn: false, loggingIn: false },
    action: any = {}
): IAuthenticationState {
    switch (action.type) {
        case AUTHENTICATION_LOGGED_IN:
            sessionStorage.setItem('zxy-token', action.user.token);

            return {
                failed: false,
                id: action.user.id,
                isChecking: false,
                loggedIn: true,
                loggingIn: false,
                permissions: {
                    canCreateDermaOthProcedure: false,
                    canCreateGhcConsult: false,
                },
                token: action.user.token,
                user: action.user,
            };
        case AUTHENTICATION_LOGOUT:
            return {
                failed: false,
                isChecking: false,
                loggedIn: false,
                loggingIn: false,
            };
        case AUTHENTICATION_CHECKING_FAILED:
            return {
                failed: false,
                isChecking: false,
                loggedIn: false,
                loggingIn: false,
            };
        case AUTHENTICATION_CHECKING:
            return {
                failed: false,
                isChecking: true,
                loggedIn: false,
                loggingIn: false,
            };
        case USER_ACTIONS_CHANGED:
            return {
                ...state,
                actions: action.actions,
            };
        case USER_PERMISSIONS_CHANGED:
            return {
                ...state,
                permissions: { ...state.permissions, ...action.permissions },
            };
        case USER_DATA_CHANGED:
            return {
                ...state,
                user: { ...state.user, ...action.user },
            };
        case USER_PROCESSES_CHANGED:
            return {
                ...state,
                processes: [...action.processes],
            };
        case USER_REQUEST_PROCESSES_CHANGED:
            return {
                ...state,
                requestProcesses: [...action.requestProcesses],
            };
        case USER_HAS_OSAS_MRA_REFERRAL_LETTER_CHANGED:
            return {
                ...state,
                userHasOsasMraReferralLetter: action.userHasOsasMraReferralLetter,
            };
        case SESSION_TIMEOUT_CHANGED:
            return {
                ...state,
                sessionTimeout: action.timeout,
            };

        case USER_INSURANCE_CHANGED:
            return {
                ...state,
                insurance: action.insurance,
            };

        default:
            return state;
    }
}

export const rootReducer: redux.Reducer<IAuthenticationState> = authentication;
